import Vue from 'vue';
import 'amfe-flexible';// rem h5 适配
import App from './App';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import {
  router
} from './router';
import {
  Lazyload,
  Grid,
  GridItem,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Icon,
  Card,
  SubmitBar,
  Progress,
  Toast,
  Form,
  Tag,
  Field,
  Button,
  CellGroup,
  Cell,
  Col,
  Row,
  Picker,
  Popup,
  Dialog,Empty,Tab,Tabs,Swipe, SwipeItem,Loading, Overlay,AddressEdit,Area,Slider,Uploader,
  Image as VanImage
} from 'vant';
Vue.use(ElementUI);
Vue.use(Area);
Vue.use(Lazyload);
Vue.use(AddressEdit);
Vue.use(VanImage);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Card);
Vue.use(SubmitBar);
Vue.use(Toast);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Col);
Vue.use(Row);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Tag);
Vue.use(Empty);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Slider);
Vue.use(Uploader);
var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
if (ua.match(/MicroMessenger/i) == "micromessenger") {
  //
}
// // 设置 rem 函数
// function setRem () {

//   let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
// //得到html的Dom元素
//   let htmlDom = document.getElementsByTagName('html')[0];
// //设置根元素字体大小
//   htmlDom.style.fontSize= htmlWidth/20 + 'px';
// }
// // 初始化
// setRem();
// // 改变窗口大小时重新设置 rem
// window.onresize = function () {
//   setRem()
// }
        
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
});